import React, { forwardRef } from 'react'
import { Button } from 'components/UIElements'
import SurveyQuestion from '../SurveyQuestion'
import {
  checkLogicAndComplete,
  getShouldRenderNextQuestion,
} from '../../utils/instrumentUtils'
import ReviewQuestionItem from '../ReviewQuestionItem'
import { LABEL } from 'utils/constants'

const completeIntroductionQuestion = props => {
  const {
    question,
    id,
    completeQuestion,
    nextQ,
    webSurvey,
    submissionSurvey,
    nextQId,
    reviewFunctionalitySupported,
    isConsent = false,
    isLastQuestion = false,
    isSibling = false,
  } = props
  const { label, type, attributes } = question
  const { required } = attributes
  const submission = {
    id,
    label,
    name: id,
    type,
    required,
    state: 'REQUIRED',
    answer: []
  }
  const currentAnswer = { [id]: [] }

  const shouldRenderNextQ = getShouldRenderNextQuestion({
    isConsent,
    isLastQuestion,
    isSibling,
  })

  checkLogicAndComplete(
    webSurvey,
    id,
    submissionSurvey,
    currentAnswer,
    nextQId,
    nextQ,
    completeQuestion,
    submission,
    reviewFunctionalitySupported,
    shouldRenderNextQ
  )
}

const shouldShowInReview = question =>
  question &&
  question.type !== 'introduction' &&
  question.type !== 'prompt' &&
  question.type !== 'resume-review' &&
  question.id !== 'resume-review' &&
  question.type !== 'resume-review-timestamp' &&
  question.id !== 'resume-review-timestamp'

const enrichQuestionsFromWebSurvey = (questions, webSurvey) => {
  const defs = webSurvey?.questions
  if (!questions?.length || !defs) return questions || []
  return questions.map(q => {
    const def = defs[q.id]
    if (!def) return q
    return {
      ...def,
      ...q,
      label: q.label || def.label,
      type: q.type || def.type,
      answer: Array.isArray(q.answer) ? q.answer : q.answer ?? def.answer ?? []
    }
  })
}

const ResumeReview = forwardRef((props, ref) => {
  const {
    scrollToPreviousQuestion,
    scrollToNextQuestion,
    webSurvey,
    id,
    submissionSurvey,
    currentAnswer,
    nextQId,
    nextQ,
    completeQuestion,
    submission,
    strings,
    storedAnswer,
    storedInstrument
  } = props

  const storageFiltered =
    storedInstrument?.questions?.filter(shouldShowInReview) || []
  const submissionFiltered =
    submissionSurvey?.questions?.filter(shouldShowInReview) || []

  const storageHasAnswers = storageFiltered.some(
    q => Array.isArray(q.answer) && q.answer.length > 0
  )
  const submissionHasAnswers = submissionFiltered.some(
    q => Array.isArray(q.answer) && q.answer.length > 0
  )

  const baseRaw =
    submissionHasAnswers && submissionFiltered.length >= storageFiltered.length
      ? submissionFiltered
      : storageHasAnswers && storageFiltered.length > 0
        ? storageFiltered
        : submissionFiltered.length > 0
          ? submissionFiltered
          : storageFiltered

  const filteredQuestions = enrichQuestionsFromWebSurvey(baseRaw, webSurvey)

  const displayQuestions = (() => {
    const baseQuestions = filteredQuestions || []
    const lastUpdated =
      storedInstrument?.last_updated || submissionSurvey?.last_updated

    if (!lastUpdated) {
      return baseQuestions
    }

    const timestampQuestion = {
      id: 'resume-review-timestamp',
      type: 'resume-review-timestamp',
      label: LABEL,
      last_updated: lastUpdated,
      answer: [],
      attributes: {},
      choices: {},
      choices_order: []
    }

    return [timestampQuestion, ...baseQuestions]
  })()

  // const filteredWebSurveyQuestions = webSurvey?.questions?.filter(
  //   question => question.type !== 'introduction',
  // )

  const onEditQuestion = id => {
    scrollToPreviousQuestion(id, '0')
  }

  return (
    <SurveyQuestion id={id}>
      <div ref={ref} className='review-content'>
        <div className='review-content-inner'>
          <div className='review-content-title'>Last received entry</div>
          <div className='review-content-list'>
            {displayQuestions?.map((question, index) => (
              <ReviewQuestionItem
                key={`${question.id ?? 'q'}-${index}`}
                question={question}
                onEditQuestion={onEditQuestion}
                strings={strings}
              />
            ))}
          </div>
          <div className='review-content-buttons'>
            {/* <Button
              className='secondary-button'
              content='Back'
              onClick={() => {
                scrollToPreviousQuestion(
                  submissionSurvey?.questions?.[
                    submissionSurvey?.questions?.length - 1
                  ]?.id,
                  '0',
                )
              }}
              icon='fa fa-chevron-up'
            /> */}
            <Button
              className='primary-button'
              content='Next'
              onClick={() => {
                completeIntroductionQuestion(props)
              }}
            />
          </div>
        </div>
      </div>
    </SurveyQuestion>
  )
})

export default ResumeReview
